import React, { FC } from 'react';
import { Theme, Box, Typography, makeStyles } from '@material-ui/core';
import { teamDescriptionBgPhoto, teamDescriptionPhoto } from 'images/about-us';

interface TeamDescriptionSectionProps {
  title: string;
  span: string;
  secondSpan: string;
  text: string;
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    marginTop: theme.spacing(26),
    backgroundColor: theme.palette.background.paper,
    backgroundImage: `url(${teamDescriptionBgPhoto})`,
    backgroundRepeat: 'no-repeat',
    display: 'block',
    [theme.breakpoints.up('lg')]: {
      display: 'flex',
    },
  },
  divider: {
    width: 100,
    height: 1,
    backgroundColor: theme.palette.primary.main,
    margin: theme.spacing(6, 0),
  },
  title: {
    color: theme.palette.common.white,
    fontWeight: 500,
  },
  text: {
    color: theme.palette.common.white,
  },
  orangeText: {
    color: theme.palette.primary.main,
  },
  content: {
    maxWidth: '90%',
    margin: theme.spacing(15, 0),
    [theme.breakpoints.up('lg')]: {
      maxWidth: 520,
    },
  },
  textBox: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
  },
  img: {
    backgroundImage: `url(${teamDescriptionPhoto})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    width: '100%',
    height: 400,
    [theme.breakpoints.up('lg')]: {
      height: 'auto',
    },
  },
}));

const TeamDescriptionSection: FC<TeamDescriptionSectionProps> = ({ title, span, secondSpan, text }) => {
  const classes = useStyles();
  return (
    <Box className={classes.root}>
      <Box className={classes.textBox}>
        <Box className={classes.content}>
          <Typography variant="h2" className={classes.title} data-aos="fade-right">
            <span className={classes.orangeText}>{span}</span> {title}
            <span className={classes.orangeText}> {secondSpan}</span>
          </Typography>
          <Box className={classes.divider} />
          <Typography variant="body1" className={classes.text} data-aos="fade-right" data-aos-delay="300">
            {text}
          </Typography>
        </Box>
      </Box>
      <Box className={classes.img} />
    </Box>
  );
};
export default TeamDescriptionSection;
